// extracted by mini-css-extract-plugin
module.exports = {"container":"_efd522a","skeleton":"_fb610e3","textSkeleton":"_4ea5d31","dropdownSection":"_c9044ba","title":"_81ebf87"};